export const ADMIN_TOKEN_KEY = 'accessAdminToken';
